
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LanguageIcon from '@mui/icons-material/Language';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import { Snowshoeing } from '@mui/icons-material';
import StyleIcon from '@mui/icons-material/Style';
import CelebrationIcon from '@mui/icons-material/Celebration';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import TtkList from './TtkList';
const SafaTTK = ({ data }) => {

    return (
        <>

            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p ><AutoFixHighIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b> No. of Events Covered :</b>&nbsp;<span> {data?.coverdofevents}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <LanguageIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Serving in Cities:</b>&nbsp;<TtkList data={data?.areaOfWorking} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Minimum Booking Quantity :</b>&nbsp;<span>{data?.minimumBookingQuantity}</span></p>
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p> <Snowshoeing sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Types Of Safa/Pagdi :</b>&nbsp;<TtkList data={data?.typeOfSafa} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <DirectionsCarFilledIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Travel Preference :</b>&nbsp;<TtkList data={data?.travelPreference} /></p>
                        </div>
                    </div>
                </div>
            </div>

        </>

    )
}

export default SafaTTK